import { useRef, useEffect, useState, useCallback } from "react";
import { Box, Flex, Button, Switch, Checkbox } from "@chakra-ui/react";
import { DeviceIcon } from "src/modules/device/components/DeviceSpec";
import { H3, BodyText2, Subtitle } from "src/atoms/typography";
import { ReactComponent as SuccessIcon } from "../icons/success.svg";

export default function Notifications({
  t,
  onToggle,
  deviceList,
  isEnabled,
  sendTestNotification,
  numberOfNotifiedDevices
}) {
  const [num, setNum] = useState(numberOfNotifiedDevices);
  const el = useRef();
  const id = useRef();
  const numRef = useRef();

  const send = useCallback(() => {
    sendTestNotification();
    el.current.style.opacity = 1;
    if (id.current) {
      clearTimeout(id.current);
      id.current = null;
    }
    id.current = setTimeout(() => {
      clearTimeout(id.current);
      id.current = null;
      el.current.style.opacity = 0;

      setNum(numRef.current);
    }, 5000);
  }, [sendTestNotification]);

  useEffect(() => {
    return () => {
      clearTimeout(id.current);
      id.current = null;
    };
  }, []);

  useEffect(() => {
    numRef.current = numberOfNotifiedDevices;
    if (numberOfNotifiedDevices !== num && !id.current) {
      setNum(numberOfNotifiedDevices);
    }
  }, [numberOfNotifiedDevices, num]);

  return (
    <Box>
      <H3>{t("scheduler.notifications.allDevices")}</H3>
      <Flex
        mt="8px"
        mb="28px"
        justifyContent="space-between"
        alignItems="center"
      >
        <BodyText2>{t("scheduler.notiications.explainer")}</BodyText2>
        <Switch isChecked={isEnabled} onChange={onToggle} />
      </Flex>
      <Box
        transition="all 0.3s"
        {...(isEnabled && {
          opacity: 0.4,
          pointerEvents: "none"
        })}
      >
        {deviceList.map((device) => {
          const { jid, name, checked } = device;
          return (
            <Flex
              mb="24px"
              key={jid}
              justifyContent="space-between"
              alignItems="center"
            >
              <Flex alignItems="center">
                <Box mr="16px">
                  <DeviceIcon deviceJid={jid} />
                </Box>
                <Subtitle color="highEmphasis">{name}</Subtitle>
              </Flex>
              <Box
                sx={{
                  ".Mui-checked": {
                    color: "primary"
                  }
                }}
              >
                <Checkbox onChange={device.onToggle} checked={checked} />
              </Box>
            </Flex>
          );
        })}
      </Box>
      <Button variant="flatPrimary" onClick={send}>
        {t("scheduler.testNotification")}
      </Button>

      <Flex
        ref={el}
        alignItems="center"
        mt="12px"
        transition="all 0.3s"
        opacity={0}
      >
        <SuccessIcon />
        <BodyText2 ml="8px">
          {t("testNotification.message", {
            value0: t("plurals:devicesCount", {
              count: num || 0
            })
          })}
        </BodyText2>
      </Flex>
    </Box>
  );
}
